import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api, { setToken } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// AuthCallback: handles the #session_id fragment returned by Emergent OAuth.
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/login");
      return;
    }
    const session_id = decodeURIComponent(match[1]);
    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id });
        // Store the token so we can send it as Authorization: Bearer on
        // subsequent requests — required when the frontend and backend are
        // on different domains (third-party cookies get blocked).
        if (data.session_token) setToken(data.session_token);
        setUser(data);
        window.history.replaceState({}, document.title, "/dashboard");
        navigate("/dashboard", { state: { user: data } });
      } catch (e) {
        navigate("/login");
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FCFCFC]" data-testid="auth-callback">
      <div className="label-eyebrow text-neutral-600">Signing you in…</div>
    </div>
  );
}
